export const queryKey = {
  myInfo: ['myInfo'],
  getInfiniteLikeFolders: ['getInfiniteLikeFolders'],
  getInfiniteRecentlyViewedGoods: ['getInfiniteRecentlyViewedGoods'],
  cartMeta: ['cartMeta'],
  configs: ['configs'],
  mainTabs: ['mainTabs'],
  proxy: (instanceId: string, url?: string) =>
    url
      ? (['proxy', instanceId, url] as const)
      : (['proxy', instanceId] as const),
  assembleTab: (queryValue: string, url: string) =>
    ['assembleTab', queryValue, url] as const,
  screenComponent: (
    screenName?: string,
    componentId?: number,
    paramValue?: string | null,
    queryName?: string,
    extraParams?: Record<string, string | null>,
  ) => [
    'atomicScreenComponent',
    screenName,
    componentId,
    paramValue,
    queryName,
    extraParams,
  ],
} as const;
